<template>
  <div class="main">
    <b-row>
      <div v-loading="formloading" class="form">
        <el-form ref="form" :inline="true" :model="form">
          <el-form-item label="Parent Borrower:">
            <el-select v-model="form.parentBorrower" placeholder="select parent borrower" style="width:250px" @change="parentBorrowerChange">
              <el-option v-for="item in form.parentBorrowerList" :key="item.id" :label="item.parentBorrowerName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Borrower:">
            <el-select v-model="form.borrower" style="width:250px" placeholder="select borrower">
              <el-option v-for="item in form.borrowerList" :key="item.id" :label="item.borrowerLegalEntity" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Effective Date:">
              <el-date-picker type="date" placeholder="Pick a date" value-format="yyyy-MM-dd" v-model="form.effectiveDate"
              @change="formDateChange" :clearable=false :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="onRefresh">Refresh</el-button>
        </el-form>
      </div>
    </b-row>
    <br>
    <b-row>
      <b-col cols="3">
        <div v-loading="loading" >
          <div class="tableDescription"> Collateral Summary </div>
          <el-table :max-height=310 :data="csData" border :header-cell-style="psHeaderStyle">
            <el-table-column v-for="item in csTitles" :key="item.prop" :prop="item.prop" :label="item.label" :align="item.align"  header-align="center">
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom" :content="slotData.row[item.prop]" :enterable=false :visible-arrow=false :offset= 75>
                  <span>{{ slotData.row[item.prop]}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </b-col>
      <b-col cols="3" style="padding-right: 0; padding-left: 0">
        <div v-loading="loading">
          <div class="searchBar">
          Search by Security Name and ID: <br>
          <el-input v-model="search" size="mini" placeholder="Search" style="margin-top:5px;margin-bottom:5px;"/>
          </div>
          <div class="tableDescription"> Recalls Past Default </div>
          <el-table :max-height=260 :data="recallsData.filter(data => !search || data.securityName.toLowerCase().includes(search.toLowerCase())  || data.securityIdentifier.toLowerCase().includes(search.toLowerCase()))" border :header-cell-style="esHeaderStyle" @sort-change="changeSort">
            <el-table-column :prop="recallsTitles[0].prop" :label="recallsTitles[0].label" :align="recallsTitles[0].align" min-width=110 sortable header-align="center">
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom-start" :content="slotData.row[recallsTitles[0].prop]" :enterable=false :visible-arrow=false :offset=75>
                  <span>{{ slotData.row[recallsTitles[0].prop]}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :prop="recallsTitles[1].prop" :label="recallsTitles[1].label" :align="recallsTitles[1].align" sortable header-align="center">
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom-start" :content="slotData.row[recallsTitles[1].prop]" :enterable=false :visible-arrow=false :offset=75>
                  <span>{{ slotData.row[recallsTitles[1].prop]}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :prop="recallsTitles[2].prop" :label="recallsTitles[2].label" :align="recallsTitles[2].align" sortable="custom" header-align="center">
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom-start" :content="slotData.row[recallsTitles[2].prop]" :enterable=false :visible-arrow=false :offset=75>
                  <span>{{ slotData.row[recallsTitles[2].prop]}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- <el-table-column v-for="item in recallsTitles" :key="item.prop" :prop="item.prop" :label="item.label" :align="item.align"  header-align="center" sortable="custom"></el-table-column> -->
          </el-table>
        </div>
      </b-col>
      <b-col cols="3" v-loading="chartsloading" >
        <div id="borrower_frame1"></div>
      </b-col>
      <b-col cols="3">
        <div v-loading="loading">
          <div class="tableDescription"> Program Concentration </div>
          <el-table :max-height=310 :data="pcData" border :header-cell-style="esHeaderStyle">
            <el-table-column v-for="item in pcTitles" :key="item.prop" :prop="item.prop" :label="item.label" :align="item.align"  header-align="center">
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom" :content="slotData.row[item.prop]" :enterable=false :visible-arrow=false :offset=75>
                  <span>{{ slotData.row[item.prop]}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col cols="6" v-loading="chartsloading" style="min-height:200px">
      <div id="borrower_frame2"> </div>
			<div id="on_loan_balance_linechart_scrollbar" style="direction: rtl; max-height: 20px; overflow: auto; width: 100%;" v-if=this.displayLoanBalanceScrollBar v-on:mouseup="updateOnLoanBalanceGraphPerScrollBarEvent">
				<div id="on_loan_balance_linechart_scrollbar_childdiv" :style=this.onLoanBalanceScrollbarCssStyle />
			</div>
      </b-col>
      <b-col cols="6" v-loading="chartsloading" style="min-height:200px">
      <div id="borrower_frame3"> </div>
			<div id="gross_earnings_linechart_scrollbar" style="direction: rtl; max-height: 20px; overflow: auto; width: 100%;" v-if=this.displayGrossEarningsScrollBar  v-on:mouseup="updateGrossEarningGraphPerScrollBarEvent">
				<div id="on_loan_balance_linechart_scrollbar_childdiv" :style=this.grossEarningsScrollbarCssStyle  />
			</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as cognosLaunch from '../utils/cognoslaunch.js';
import * as dataUtil from '../utils/DataUtil.js';
import * as dateUtil from '../utils/DateUtil.js';
import HTTP_API from '@/utils/http-api'
import GRAPHICS_HTTP_API from '@/utils/graphics-http-api'
import * as pieChartUtil from '../utils/PieChartUtility.js';

export default {
  name: 'Borrower',
  data () {
    return {
      date: new Date(),
      search: '',
      lenderId:'',
	  currentChartOptions: {},
	  displayGrossEarningsScrollBar: false,
	  displayLoanBalanceScrollBar: false,
	  onLoanBalanceDisplayPercentage: .50,
	  onLoanBalanceScrollbarCssStyle: 'width:714px;height:100px',	  
	  grossEarningsDisplayPercentage: .50,
	  grossEarningsChartTickInterval: 3600 * 1000 * 24 * 1,  //monthly
	  onLoanBalanceTickInterval: 3600 * 1000 * 24 * 1,  //monthly
	  grossEarningsScrollbarCssStyle: 'width:3000px;height:100px',	
	  grossEarningsDataZero : '',
	  grossEarningsDataOne : '',
	  grossEarningsDataTwo : '',
	  grossEarningsChartOptions: {},
	  onLoanBalanceChartOptions: {},
	  OnLoanChartClone: {},
	  grossEarningsChartBack: {},
	  grossEarningsData: '',
	  onLoanBalanceData: '',
      currencyCode: '',
      loading: false,
      formloading: false,
      chartsloading: false,
      months: dateUtil.getMonthNames(),
      form: {
        parentBorrowerList: [],
        parentBorrower: '',
        effectiveDate: '',
        borrowerList: [],
        borrower: '',
        defaultEffectiveDate: '',
        earliestDate: ''
      },
      csData: [],
      recallsData: [],
      pcData: [],
      csTitles: [
        { prop: 'label', label: '', align: 'left'},
        { prop: 'value', label: '', align: 'right'}
      ],
      recallsTitles: [
        { prop: 'securityName', label: 'Security Name', align: 'left'},
        { prop: 'securityIdentifier', label: 'ID', align: 'right'},
        { prop: 'recallDefaultDate', label: 'Default', align: 'right'}
      ],
      pcTitles: [
        { prop: 'borrower_NAME', label: 'Borrower', align: 'right'},
        { prop: 'program_CONCENTRATION_percent', label: 'Concentration', align: 'right'}
      ],
      parentBorrowerListAll: [{id:-1,parentBorrowerName: "ALL"}],
      borrowerListAll: [{id:-1,borrowerLegalEntity: "ALL"}],
      pickerOptions: {
        disabledDate(time) {
          var date = new Date();
          var yesterday = new Date();
          yesterday.setDate(date.getDate()-1)
          return time.getTime() > yesterday.getTime();
        }
      }
    }
  },

  methods:{
			updateOnLoanBalanceGraphPerScrollBarEvent(event){
				this.OnLoanChartClone.customized.realEstate = 'borrower_frame2';

				var vm = this;
				
				var scrollageIndex = this.processScrollBarData(event);		
				var beginningPercent = scrollageIndex.leftScrollPercent;
				var endingPercent = beginningPercent + this.onLoanBalanceDisplayPercentage;

				var currentChart = Object.assign({}, this.OnLoanChartClone)
				var currentSeries = currentChart.series;

				var localDiscs = currentSeries[0].data;
				var localExecs = currentSeries[1].data;
				var localTotals = currentSeries[2].data;
				
				var localSeries = [
					{
						name: 'Discretionary On Loan',
						data: localDiscs
					}, {
						name: 'Exclusive On Loan',
						data: localExecs
					}, {
						name: 'Total On Loan',
						data: localTotals
					}
				];

				currentChart.series = localSeries;
				
				var yearInMilliseconds = 3600 * 24 * 366 * 1000;
				var nowInMilliseconds = new Date().getTime();
				var yearAgoInMilliseconds = nowInMilliseconds - yearInMilliseconds;
				var startRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * beginningPercent);
				var endRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * endingPercent);
				
				var filteredDiscs = dataUtil.selectRecordsWithinRangePerDateIndex(localDiscs, 0, startRangeMillis, endRangeMillis);	
				var filteredExecs = dataUtil.selectRecordsWithinRangePerDateIndex(localExecs, 0, startRangeMillis, endRangeMillis);	
				var filteredTotals = dataUtil.selectRecordsWithinRangePerDateIndex(localTotals, 0, startRangeMillis, endRangeMillis);	

				currentChart.series[0].data = filteredDiscs;
				currentChart.series[1].data = filteredExecs;
				currentChart.series[2].data = filteredTotals;

				currentChart.title.text = "On Loan Balance";
				
				currentChart.xAxis.tickInterval = vm.onLoanBalanceTickInterval;

				var Highcharts = require('highcharts');
				require('highcharts/modules/exporting')(Highcharts);
				
				Highcharts.chart("borrower_frame2", currentChart);
			},
			updateGrossEarningGraphPerScrollBarEvent(event){
				var vm = this;

				var scrollageIndex = this.processScrollBarData(event);		
				var beginningPercent = scrollageIndex.leftScrollPercent;
				var endingPercent = beginningPercent + this.grossEarningsDisplayPercentage;
				
				//advisory:("!this.grossEarningsDisplayPercentage: |" + this.grossEarningsDisplayPercentage + "|  beginningPercent: |" + beginningPercent + "|  endingPercent |" + endingPercent + "|");


				var currentChart = Object.assign({}, this.grossEarningsChartOptions)
				
				var localDiscs = this.grossEarningsDataZero;
				var localExecs = this.grossEarningsDataOne;
				var localTotals = this.grossEarningsDataTwo;
				
				var yearInMilliseconds = 3600 * 24 * 366 * 1000;
				var nowInMilliseconds = new Date().getTime();
				var yearAgoInMilliseconds = nowInMilliseconds - yearInMilliseconds;
				var startRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * beginningPercent);
				var endRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * endingPercent);
				
				var filteredDiscs = dataUtil.selectRecordsWithinRangePerDateIndex(localDiscs, 0, startRangeMillis, endRangeMillis);	
				var filteredExecs = dataUtil.selectRecordsWithinRangePerDateIndex(localExecs, 0, startRangeMillis, endRangeMillis);	
				var filteredTotals = dataUtil.selectRecordsWithinRangePerDateIndex(localTotals, 0, startRangeMillis, endRangeMillis);	
				
				var localSeries = [
					{
						name: 'Discretionary On Loan',
						data: filteredDiscs
					}, {
						name: 'Exclusive On Loan',
						data: filteredExecs
					}, {
						name: 'Total On Loan',
						data: filteredTotals
					}
				];

				currentChart.xAxis.tickInterval = vm.grossEarningsChartTickInterval;
				currentChart.series = localSeries;
				
				var Highcharts = require('highcharts');
				require('highcharts/modules/exporting')(Highcharts);
				
				Highcharts.chart("borrower_frame3", currentChart);
			},
			  processScrollBarData: function (event) {
					
				var scrollBar = event.target;
				var scrollSpan = scrollBar.scrollWidth;
				var leftScrollPoint = scrollBar.scrollLeft;

				var rightAdjustedLeftScrollPoint = scrollSpan + leftScrollPoint;

				if(leftScrollPoint < 0){
					leftScrollPoint = rightAdjustedLeftScrollPoint - 713;
				}


				var leftScrollPercent = leftScrollPoint/scrollSpan;
				
				var thumblength = parseInt(scrollBar.style.width);			
				var rightScrollPoint = leftScrollPoint + thumblength;
				var rightScrollPercent = rightScrollPoint/scrollSpan;

			  var scrollage = {
				  rightScrollPercent: rightScrollPercent,
				  leftScrollPercent : leftScrollPercent
			  }
				  
				return scrollage;
			},
		convertDateFormat(oldDate){
			// '18-MAY-21'
			var newDate = oldDate
			try{
			  var year = oldDate.substring(2, 4)
			  var monthIndex = oldDate.substring(5, 7)
			  //var monthIndex = - 1

			  var month = dateUtil.getMonthNames()[monthIndex - 1]

			  var day = oldDate.substring(8, 10)

			  newDate = day + "-" + month + "-" + year

			}catch(error){
				console.log("Error in convertDateFormat: |" + JSON.stringify(error) + "|")
			}

			return newDate
		},
		changeSort(columninfo){
		var vm = this
		var fieldName= columninfo.column.property
		if (fieldName == "recallDefaultDate"){
			vm.recallsData = vm.recallsData.sort(
			function (a,b) {
				var year_a = parseFloat(a[fieldName].split("/")[2])
				var year_b = parseFloat(b[fieldName].split("/")[2])
				var month_a = parseFloat(a[fieldName].split("/")[0])
				var month_b = parseFloat(b[fieldName].split("/")[0])
				var day_a = parseFloat(a[fieldName].split("/")[1])
				var day_b = parseFloat(b[fieldName].split("/")[1])
				if (columninfo.column.order == "descending"){
				if ((year_b - year_a) != 0){
					return year_b - year_a
				} else if((month_b - month_a) != 0){
					return month_b - month_a
				} else {
					return day_b - day_a
				}
				}else{
				if ((year_a - year_b) != 0){
					return year_a - year_b
				} else if((month_a - month_b) != 0){
					return month_a - month_b
				} else {
					return day_a - day_b
				}
				}
			}
			)
		}
		},
		getBorrowerTabCharts(vm, lenderId, borrowerId, parentBorrowerId, currencyCode, startDate, endDate, effectiveDate){

      this.chartsloading = true;
			var Highcharts = require('highcharts');
			require('highcharts/modules/exporting')(Highcharts);

			var convertedDate = dateUtil.getDateFromString(startDate)
			var startDateStamp =  convertedDate.getTime()

			var pieChartTemplate = {
				chart: {
					backgroundColor: "#FAFAFA",
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: "pie",
					chartIndex: '',
					slices: []
				},
				navigation: {
					buttonOptions: {
						theme: {
							"stroke-width": 1,
							stroke: "silver",
							r: 0,
							states: {
								hover: {
									fill: "#bada55",
								},
								select: {
									stroke: "#039",
									fill: "#bada55",
								},
							},
						},
					},
				},
				title: {
					text: "On Loan Market Value By Country",
					style: {
						fontSize: '15px'
					}
				},
        credits: {
          enabled: false
        },
				graphIndex: 0,
				tooltip: {
				formatter: function () {
							return "<b>" + this.point.name + "</b>: " +  dataUtil.getCurrencySymbol(currencyCode) + " " + Math.round(this.y).toLocaleString("en-US");
						}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: "pointer",
						size: '200',
						dataLabels: {
							enabled: true,
							format: "<b>{point.name}</b>: {point.percentage:.1f} %",
							style: {
								color:
									(Highcharts.theme && Highcharts.theme.contrastTextColor) ||
									"black",
							},
						},
					},
				},
				series: [
					{
						colorByPoint: true,
						data: [],
						showInLegend: false
					},
					],
					xAxis: {
						categories: [],
					},
					chartIndex: "",
			};

			var lineChartTemplate = {
        chart: {
          backgroundColor: "#FAFAFA",
        },
        credits: {
					enabled: false
        },
					customized:{
						purview: '',
						realEstate: '',
						data: [],
						discOnLoanMarketValues: [],
						parens: ''
					},
      tooltip: {
        shared: true,
        crosshairs: true,
        borderRadius : 8,
        formatter: function () {
        var symbol = dataUtil.getCurrencySymbol(currencyCode);

        var s = '<b>' + Highcharts.dateFormat('%b %e, %Y', this.x) + '</b>';

        this.points.forEach((point, i)=>{
              s += '<br/> <b style="font-weight: bold;color :'
                  + point.series.color + '">' + point.series.name
                  + ':</b> ' + symbol + '  ' + dataUtil.formatCurrency(point.y);

            });

    			return s;
                }
      },
					navigation: {
						buttonOptions: {
							theme: {
								"stroke-width": 1,
								stroke: "silver",
								r: 0,
								states: {
									hover: {
										fill: "#bada55",
									},
									select: {
										stroke: "#039",
										fill: "#bada55",
									},
								},
							},
						},
					},
					exporting: {
						buttons: {
							contextButton: {
								enabled: true,
							},
							mtdButton: {
								text: "MTD",
								align: "center",
								y: 25,
								x: -100,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = null;
										var now = null;
										
										var latestRecord = '';	

										if(this.options.customized.chartName == 'grossEarningsChart'){
											latestRecord = dataUtil.getLastRecordForBorrowerView(vm, 'grossEarningsData');	
										} else{
											latestRecord = dataUtil.getLastRecordForBorrowerView(vm.onLoanBalanceData);	
										}
										
										if(latestRecord != null){											
											now = new Date(latestRecord['effectiveDate']);
											day1 = dataUtil.determineFirstDayOfMonthContainngTimeVal(latestRecord['effectiveDate']);
										}
										
										var deltaAsPercentOfYear = (now.getTime() - day1.getTime())/31556952000										
										var dataDisplayPercentage = deltaAsPercentOfYear;
										var scrollBarCssStyle = dataUtil.getScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										

										var onLoanBalanceSummaries = this.options.customized.data['onLoanBalanceLoanSummaries']

										var discretionaries = this.options.customized.data['discretionary']
										discretionaries = dataUtil.getRecordsWithinRange(discretionaries, day1, now)

										var exclusives = this.options.customized.data['exclusive']
										exclusives = dataUtil.getRecordsWithinRange(exclusives, day1, now)

										var totals = this.options.customized.data['total']
										totals = dataUtil.getRecordsWithinRange(totals, day1, now)

										onLoanBalanceSummaries = dataUtil.getRecordsWithinRange(onLoanBalanceSummaries, day1, now)
										
										if(this.options.customized.purview == 'grossearnings'){
											discretionaries = pieChartUtil.parseLineData(discretionaries, 'effectiveDate','earningsAmount')
											exclusives = pieChartUtil.parseLineData(exclusives,'effectiveDate', 'earningsAmount')
											totals = pieChartUtil.parseLineData(totals, 'effectiveDate', 'earningsAmount')
											
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;																																	
											vm.displayGrossEarningsScrollBar = true;											
										} else{
											discretionaries = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'discOnLoanMarketValue')
											exclusives = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'excOnLoanMarketValue')
											totals = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'totalOnLoanMarketValue')
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;											
											vm.displayLoanBalanceScrollBar = true;	
										}

										this.options.series[0].data = discretionaries
										this.options.series[1].data = exclusives
										this.options.series[2].data = totals
										
										var currentTickInterval = 3600 * 1000 * 24 * 1 //daily

										if(this.options.customized.purview == 'grossearnings'){
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsChartTickInterval = currentTickInterval;											
										} else{
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceTickInterval = currentTickInterval;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;
										
										Highcharts.chart(this.options.customized.realEstate, this.options);																				
									} catch (error) {
										console.log("error: |" + error + "|");
									}
								},
							},
							oneMonthButton: {
								text: "1m",
								align: "center",
								y: 25,
								x: -50,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = dateUtil.getCurrentDateMinusDays(31)
										var now = new Date()

										var dataDisplayPercentage = 0.083;
										var scrollBarCssStyle = dataUtil.getScrollBarCssPerDisplayPercentage(dataDisplayPercentage);

										var onLoanBalanceSummaries = this.options.customized.data['onLoanBalanceLoanSummaries']

										var discretionaries = this.options.customized.data['discretionary']
										discretionaries = dataUtil.getRecordsWithinRange(discretionaries, day1, now)
										onLoanBalanceSummaries = dataUtil.getRecordsWithinRange(onLoanBalanceSummaries, day1, now)
										if(this.options.customized.purview == 'grossearnings'){
											discretionaries = pieChartUtil.parseColumnValues(discretionaries, 'earningsAmount')
										} else{
											discretionaries = pieChartUtil.parseColumnValues(onLoanBalanceSummaries, 'discOnLoanMarketValue')
										}

										var exclusives = this.options.customized.data['exclusive']
										exclusives = dataUtil.getRecordsWithinRange(exclusives, day1, now)

										if(this.options.customized.purview == 'grossearnings'){
											exclusives = pieChartUtil.parseColumnValues(exclusives, 'earningsAmount')
										} else{
											exclusives = pieChartUtil.parseColumnValues(onLoanBalanceSummaries, 'excOnLoanMarketValue')
										}

										var totalRecordsFullData = this.options.customized.data['total']
										var totals = this.options.customized.data['total']
										totals = dataUtil.getRecordsWithinRange(totals, day1, now)

										if(this.options.customized.purview == 'grossearnings'){
											totals = pieChartUtil.parseLineData(totals, 'effectiveDate', 'earningsAmount')

											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;																						

											vm.displayGrossEarningsScrollBar = true;	
										} else{
											totals = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'totalOnLoanMarketValue')
											
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;											
											vm.displayLoanBalanceScrollBar = true;	
										}

										discretionaries = []
										exclusives = []

										this.options.series[0].data = discretionaries
										this.options.series[1].data = exclusives
										this.options.series[2].data = totals

										var currentTickInterval = 3600 * 1000 * 24 * 7 //weekly

										if(this.options.customized.purview == 'grossearnings'){
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsChartTickInterval = currentTickInterval;											
										} else{
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceTickInterval = currentTickInterval;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;
										
										Highcharts.chart(this.options.customized.realEstate, this.options);										
									} catch (error) {
										console.log("error: |" + error + "|");
									}
								},
							},
							threeMonthButton: {
								text: "3m",
								align: "center",
								y: 25,
								x: 0,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = dateUtil.getCurrentDateMinusDays(90)
										var now = new Date()

										var dataDisplayPercentage = 0.25;
										var scrollBarCssStyle = dataUtil.getScrollBarCssPerDisplayPercentage(dataDisplayPercentage);

										var onLoanBalanceSummaries = this.options.customized.data['onLoanBalanceLoanSummaries']

										var discretionaries = this.options.customized.data['discretionary']
										discretionaries = dataUtil.getRecordsWithinRange(discretionaries, day1, now)

										var exclusives = this.options.customized.data['exclusive']
										exclusives = dataUtil.getRecordsWithinRange(exclusives, day1, now)

										var totals = this.options.customized.data['total']
										totals = dataUtil.getRecordsWithinRange(totals, day1, now)

										onLoanBalanceSummaries = dataUtil.getRecordsWithinRange(onLoanBalanceSummaries, day1, now)

										if(this.options.customized.purview == 'grossearnings'){
											discretionaries = pieChartUtil.parseLineData(discretionaries, 'effectiveDate','earningsAmount')
											exclusives = pieChartUtil.parseLineData(exclusives,'effectiveDate', 'earningsAmount')
											totals = pieChartUtil.parseLineData(totals, 'effectiveDate', 'earningsAmount')
											
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;																																	
											vm.displayGrossEarningsScrollBar = true;
											
										} else{
											discretionaries = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'discOnLoanMarketValue')
											exclusives = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'excOnLoanMarketValue')
											totals = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'totalOnLoanMarketValue')

											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										this.options.series[0].data = discretionaries
										this.options.series[1].data = exclusives
										this.options.series[2].data = totals
										
										var currentTickInterval = 3600 * 1000 * 24 * 14 //bi-weekly

										if(this.options.customized.purview == 'grossearnings'){
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsChartTickInterval = currentTickInterval;											
										} else{
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceTickInterval = currentTickInterval;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;
										
										Highcharts.chart(this.options.customized.realEstate, this.options);																				
									} catch (error) {
										console.log("error: |" + error + "|");
									}
								},

							},
							sixMonthButton: {
								text: "6m",
								align: "center",
								y: 25,
								x: 50,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {
										var day1 = dateUtil.getCurrentDateMinusDays(120)
										
										var dataDisplayPercentage = 0.5;
										var scrollBarCssStyle = dataUtil.getScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										

										var now = new Date()

										var onLoanBalanceSummaries = this.options.customized.data['onLoanBalanceLoanSummaries']

										var discretionaries = this.options.customized.data['discretionary']
										discretionaries = dataUtil.getRecordsWithinRange(discretionaries, day1, now)

										var exclusives = this.options.customized.data['exclusive']
										exclusives = dataUtil.getRecordsWithinRange(exclusives, day1, now)

										var totals = this.options.customized.data['total']
										totals = dataUtil.getRecordsWithinRange(totals, day1, now)

										onLoanBalanceSummaries = dataUtil.getRecordsWithinRange(onLoanBalanceSummaries, day1, now)
										
										if(this.options.customized.purview == 'grossearnings'){
											discretionaries = pieChartUtil.parseLineData(discretionaries, 'effectiveDate','earningsAmount')
											exclusives = pieChartUtil.parseLineData(exclusives,'effectiveDate', 'earningsAmount')
											totals = pieChartUtil.parseLineData(totals, 'effectiveDate', 'earningsAmount')

											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;																						
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											discretionaries = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'discOnLoanMarketValue')
											exclusives = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'excOnLoanMarketValue')
											totals = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'totalOnLoanMarketValue')

											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;	
										}

										this.options.series[0].data = discretionaries
										this.options.series[1].data = exclusives
										this.options.series[2].data = totals
										
										var currentTickInterval = 3600 * 1000 * 24 * 31 //monthly
										
										if(this.options.customized.purview == 'grossearnings'){
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsChartTickInterval = currentTickInterval;	
										} else{
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceTickInterval = currentTickInterval;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;
										
										Highcharts.chart(this.options.customized.realEstate, this.options);																				
									} catch (error) {
										console.log("error: |" + error + "|");
									}
								},
							},
							oneYearButton: {
								text: "1Y",
								align: "center",
								y: 25,
								x: 100,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = dateUtil.getCurrentDateMinusDays(366)
										var now = new Date()

										var dataDisplayPercentage = 1;
										var scrollBarCssStyle = dataUtil.getScrollBarCssPerDisplayPercentage(dataDisplayPercentage);
										
										var onLoanBalanceSummaries = this.options.customized.data['onLoanBalanceLoanSummaries']

										var discretionaries = this.options.customized.data['discretionary']
										discretionaries = dataUtil.getRecordsWithinRange(discretionaries, day1, now)

										var exclusives = this.options.customized.data['exclusive']
										exclusives = dataUtil.getRecordsWithinRange(exclusives, day1, now)

										var totals = this.options.customized.data['total']
										totals = dataUtil.getRecordsWithinRange(totals, day1, now)

										onLoanBalanceSummaries = dataUtil.getRecordsWithinRange(onLoanBalanceSummaries, day1, now)

										if(this.options.customized.purview == 'grossearnings'){
											discretionaries = pieChartUtil.parseLineData(discretionaries, 'effectiveDate','earningsAmount')
											exclusives = pieChartUtil.parseLineData(exclusives,'effectiveDate', 'earningsAmount')
											totals = pieChartUtil.parseLineData(totals, 'effectiveDate', 'earningsAmount')

											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;																						
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											discretionaries = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'discOnLoanMarketValue')
											exclusives = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'excOnLoanMarketValue')
											totals = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'totalOnLoanMarketValue')

											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										this.options.series[0].data = discretionaries
										this.options.series[1].data = exclusives
										this.options.series[2].data = totals
										
										var currentTickInterval = 3600 * 1000 * 24 * 31 //monthly

										if(this.options.customized.purview == 'grossearnings'){
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsChartTickInterval = currentTickInterval;											
										} else{
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceTickInterval = currentTickInterval;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;
										
										Highcharts.chart(this.options.customized.realEstate, this.options);																				
									} catch (error) {
										console.log("error: |" + error + "|");
									}
								},
							},
							yearToDateButton: {
								text: "YTD",
								align: "center",
								y: 25,
								x: 150,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = dateUtil.getFirstDayOfThisYear()
										var now = new Date()
										var deltaAsPercentOfYear = (now.getTime() - day1.getTime())/31556952000
										
										var dataDisplayPercentage = deltaAsPercentOfYear;
										var scrollBarCssStyle = dataUtil.getScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										

										var onLoanBalanceSummaries = this.options.customized.data['onLoanBalanceLoanSummaries']

										var discretionaries = this.options.customized.data['discretionary']
										discretionaries = dataUtil.getRecordsWithinRange(discretionaries, day1, now)

										var exclusives = this.options.customized.data['exclusive']
										exclusives = dataUtil.getRecordsWithinRange(exclusives, day1, now)

										var totals = this.options.customized.data['total']
										totals = dataUtil.getRecordsWithinRange(totals, day1, now)

										onLoanBalanceSummaries = dataUtil.getRecordsWithinRange(onLoanBalanceSummaries, day1, now)

										if(this.options.customized.purview == 'grossearnings'){
											discretionaries = pieChartUtil.parseLineData(discretionaries, 'effectiveDate','earningsAmount')
											exclusives = pieChartUtil.parseLineData(exclusives,'effectiveDate', 'earningsAmount')
											totals = pieChartUtil.parseLineData(totals, 'effectiveDate', 'earningsAmount')
											
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;																																	
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											discretionaries = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'discOnLoanMarketValue')
											exclusives = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'excOnLoanMarketValue')
											totals = pieChartUtil.parseLineData(onLoanBalanceSummaries, 'effectiveDate', 'totalOnLoanMarketValue')
											
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;											
											vm.displayLoanBalanceScrollBar = true;	
										}

										this.options.series[0].data = discretionaries
										this.options.series[1].data = exclusives
										this.options.series[2].data = totals

										var currentTickInterval = 3600 * 1000 * 24 * 31 //monthly

										if(this.options.customized.purview == 'grossearnings'){
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsChartTickInterval = currentTickInterval;											
										} else{
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceTickInterval = currentTickInterval;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;
										
										Highcharts.chart(this.options.customized.realEstate, this.options);																				
									} catch (error) {
										console.log("error: |" + error + "|");
									}
								}
							},
						},
					},
					title: {
						text: ''
					},
					subtitle: {
						text: ''
					},
					yAxis: {
							title: {
							text: null
							},
							labels: {
								formatter: function () {
									return dataUtil.getCurrencySymbol(currencyCode) + " " + dataUtil.formatCurrency(this.value, 0);
								}
							}
						},
					xAxis: {
						title: {
							text: null
						},
						type: 'datetime',
						tickInterval: 3600 * 1000 * 24 * 61 // 2 days
					},
					legend: {
						layout: 'horizontal',
						align: 'center',
						verticalAlign: 'bottom'
					},
					plotOptions: {
						series: {
							label: {
								connectorAllowed: false
							},
							// pointStart: Date.UTC(2010, 0, 1),
							pointStart: startDateStamp,
							pointInterval: 3600 * 1000 * 24 // one day
						}
					},
					series: [],
					responsive: {
						rules: [{
							condition: {
								maxWidth: 500
							},
							chartOptions: {
								legend: {
									layout: 'horizontal',
									align: 'center',
									verticalAlign: 'bottom'
								}
							}
						}]
					}
			}
			lineChartTemplate.title.text = 'Gross Earnings Points';
			var dateBoundXAxis =  {
					type: 'datetime',
					dateTimeLabelFormats: { // don't display the dummy year
						month: '%e. %b',
						year: '%b'
					},
					title: {
						text: 'Date'
					}
			};

			var discretionaryRecords = []
			var exclusiveRecords = []
			var totalRecords = []


			var discretionaryEarnings = {}
			var grossEarningsExclusiveRecords = []
			var grossEarningsDiscRecords = []
			var grossEarningsTotalRecords = []

			var totalExclusiveEarnings = []
			var totalDiscretionaryEarnings = []
			var totalEarnings = []

			var onLoanBalanceLoanSummaries = []
			var totalOnLoanMarketValues = []
			var totalOnLoanMarketValuesBack = []
			var discOnLoanMarketValues = []
			var discOnLoanMarketValuesBack = []

			var excOnLoanMarketValues = []
			var excOnLoanMarketValuesBack = []

			var postBody = {};
			postBody.lenderId = lenderId;
			postBody.currencyCode = currencyCode;
			postBody.startDateString = startDate;
			postBody.endDateString = endDate;
			postBody.borrowerId = borrowerId;
			postBody.parentBorrowerId = parentBorrowerId;
			postBody.effectiveDateString = effectiveDate

			GRAPHICS_HTTP_API.post('/borrowertabchartdata',postBody).then(response => {
				var retVal = response.data

				var loanSummaryDataRecordset = retVal.loanSummaryByAsset
				var pie1 = Object.assign({}, pieChartTemplate)
				pie1.chartIndex = 0
				pie1.title.text = 'Borrower Exposure By Asset Class'
        		pie1.title.style = { "fontSize": "13px" ,"font-weight": "bold", "padding-bottom": "0px", "margin-bottom": "0px"}
				var pieFilling1 = pieChartUtil.recordsetToPieFilling(loanSummaryDataRecordset, 'securityType', 'totalOnLoanMarketValue')
				pie1.chart.slices = pieFilling1
				pie1.series[0].data = pieFilling1;
				pie1.realEstate = 'borrower_frame1'
				var pieColumnNames1 = pieChartUtil.parseColumnValues(
						loanSummaryDataRecordset, "securityType");

				Highcharts.chart(pie1.realEstate, pie1);

				grossEarningsExclusiveRecords = retVal.totalExclusiveEarnings
				exclusiveRecords['grossEarnings'] = retVal.totalExclusiveEarnings

				grossEarningsDiscRecords = retVal.totalDiscretionaryEarnings

				discretionaryRecords['grossEarnings'] = retVal.totalDiscretionaryEarnings
				grossEarningsTotalRecords = retVal.totalEarnings
				totalRecords['grossEarnings'] = retVal.totalEarnings

				onLoanBalanceLoanSummaries = retVal.onLoanBalanceLoanSummaries
				vm.onLoanBalanceData = onLoanBalanceLoanSummaries;

				discOnLoanMarketValues = pieChartUtil.parseLineData(onLoanBalanceLoanSummaries, "effectiveDate", "discOnLoanMarketValue")
				discOnLoanMarketValuesBack = pieChartUtil.parseLineData(onLoanBalanceLoanSummaries, "effectiveDate", "discOnLoanMarketValue")

				excOnLoanMarketValues = pieChartUtil.parseLineData(onLoanBalanceLoanSummaries, 'effectiveDate', 'excOnLoanMarketValue')
				excOnLoanMarketValuesBack = pieChartUtil.parseLineData(onLoanBalanceLoanSummaries, 'effectiveDate', 'excOnLoanMarketValue')


				totalOnLoanMarketValues = pieChartUtil.parseLineData(onLoanBalanceLoanSummaries, 'effectiveDate', 'totalOnLoanMarketValue')
				totalOnLoanMarketValuesBack = pieChartUtil.parseLineData(onLoanBalanceLoanSummaries, 'effectiveDate', 'totalOnLoanMarketValue')

				totalDiscretionaryEarnings = pieChartUtil.parseColumnValues(grossEarningsDiscRecords, 'earningsAmount')
				discretionaryEarnings = pieChartUtil.parseLineData(grossEarningsDiscRecords, 'effectiveDate', 'earningsAmount')
				totalExclusiveEarnings = pieChartUtil.parseLineData(grossEarningsExclusiveRecords, 'effectiveDate', 'earningsAmount')
				totalEarnings = pieChartUtil.parseLineData(grossEarningsTotalRecords, "effectiveDate", "earningsAmount")
        		this.chartsloading = false;
			}).catch(function (error) {
        		this.chartsloading = false;
				console.log("error: |" + JSON.stringify(error) + "|")
			}).finally(function(){

				var onLoanChart = Object.assign({}, lineChartTemplate)
				var OnLoanChartClone = Object.assign({}, lineChartTemplate)

				//One dataset holds records for all three lines, in the case of the 'On Loan Balance' Line Chart:
				onLoanChart.customized.data['discretionary'] = onLoanBalanceLoanSummaries
				onLoanChart.customized.data['exclusive'] = onLoanBalanceLoanSummaries
				onLoanChart.customized.data['total'] = onLoanBalanceLoanSummaries
				onLoanChart.customized.data['onLoanBalanceLoanSummaries'] = onLoanBalanceLoanSummaries
				onLoanChart.parent = this

				var totalOnLoanSeries1 = [
					{
						name: 'Discretionary On Loan',
						data: discOnLoanMarketValues
					}, {
						name: 'Exclusive On Loan',
						data: excOnLoanMarketValues
					}, {
						name: 'Total On Loan',
						data: totalOnLoanMarketValues
					}
					]

				var totalOnLoanSeries1Back = [
					{
						name: 'Discretionary On Loan',
						data: discOnLoanMarketValuesBack
					}, {
						name: 'Exclusive On Loan',
						data: excOnLoanMarketValuesBack
					}, {
						name: 'Total On Loan',
						data: totalOnLoanMarketValuesBack
					}
					]


				onLoanChart.series = totalOnLoanSeries1;
				onLoanChart.title.text = 'On Loan Balance'
				onLoanChart.title.style = { "fontSize": "13px" ,"font-weight": "bold"}
				onLoanChart.customized.realEstate = 'borrower_frame2'

				OnLoanChartClone.series = totalOnLoanSeries1Back;
				OnLoanChartClone.title.text = 'On Loan Balance'
				OnLoanChartClone.title.style = { "fontSize": "13px" ,"font-weight": "bold"}
				OnLoanChartClone.customized.realEstate = 'borrower_frame2'
				
				
				vm.OnLoanChartClone = OnLoanChartClone;
			

				Highcharts.chart(onLoanChart.customized.realEstate, onLoanChart);

				var grossEarningsChart = Object.assign({}, lineChartTemplate)
				grossEarningsChart.customized.purview="grossearnings"

				grossEarningsChart.title.text = 'Gross Earnings'
				grossEarningsChart.title.style = { "fontSize": "13px" ,"font-weight": "bold"}

				var grossEarningsSeries = [
							{
								name: 'Discretionary Earnings',
								data: discretionaryEarnings
							}, {
								name: 'Exclusive Earnings',
								data: totalExclusiveEarnings
							}, {
								name: 'Total Earnings',
								data: totalEarnings
							}
							]

				var grossEarningsData = [];

				vm.grossEarningsDataZero = discretionaryEarnings;
				Array.prototype.push.apply(grossEarningsData, discretionaryEarnings);	
				
				vm.grossEarningsDataOne = totalExclusiveEarnings;
				Array.prototype.push.apply(grossEarningsData, totalExclusiveEarnings);	
				
				vm.grossEarningsDataTwo = totalEarnings;				
				Array.prototype.push.apply(grossEarningsData, totalEarnings);
				vm.grossEarningsData = grossEarningsData;

				grossEarningsChart.series = grossEarningsSeries;
				grossEarningsChart.customized.data['discretionary'] = discretionaryRecords['grossEarnings']
				grossEarningsChart.customized.data['exclusive'] = exclusiveRecords['grossEarnings']
				grossEarningsChart.customized.data['total'] = totalRecords['grossEarnings']
				grossEarningsChart.customized.realEstate = 'borrower_frame3'
				
				Highcharts.chart(grossEarningsChart.customized.realEstate, grossEarningsChart);
				
				vm.OnLoanChartClone.customized.purview='onloanbalance';
			}); //close finally
		},  //close getBorrowerCharts
    getBorrowerData(){
      var vm = this
      vm.loading=true;
      vm.formloading=true;
      HTTP_API.get('/borrower/borrowerdashboard')
      .then(response => {
        // console.log("borrower data")
        console.log(response)
        vm.form.defaultEffectiveDate = response.data.effectiveDate.split("T")[0]
		vm.form.effectiveDate = response.data.effectiveDate.split("T")[0]
		vm.currencyCode = response.data.prefReportingCurr
		vm.lenderId = response.data.lenderId
		
        var monthNow =vm.date.getMonth()
        var yearNow = vm.date.getFullYear();
        var dayNow = vm.date.getDate();
        var dateNow = yearNow + '-'+ monthNow + '-'+ dayNow;
        var defaultReportArr = dateNow.split("-");
        vm.form.earliestDate = new Date(parseInt(defaultReportArr[0], 10) - 1, parseInt(defaultReportArr[1], 10) - 1, 1);
        vm.form.borrowerList = vm.borrowerListAll
        vm.form.borrower = -1
        vm.form.parentBorrower = -1
        vm.form.parentBorrowerList = vm.parentBorrowerListAll.concat(response.data.parentBorrowerList)
        vm.getTablesData()
        // vm.loading=false;

		var startDateFull = dateUtil.getCurrentDateMinusDays(366)
		var startDate = dateUtil.toDateString(startDateFull)

		var endDateFull = dateUtil.getCurrentDateMinusDays(1)
		var endDate = dateUtil.toDateString(endDateFull)
		var startDateMillis = startDateFull.getTime()

		var effectiveDate = vm.convertDateFormat(vm.form.effectiveDate)
      	vm.getBorrowerTabCharts(vm, vm.lenderId, vm.form.borrower, vm.form.parentBorrower, vm.currencyCode, startDate, endDate, effectiveDate)
      })
      .catch(function (error) {
        console.log(error.response)
        vm.loading=false;
        vm.formloading=false;
      });
	},
    getBorrowerList(parentBorrowerId){
      var vm = this
      // console.log("getting borrower data")
      var paramSet = {}
      paramSet.lenderId = this.lenderId;
      paramSet.parentBorrowerId = parentBorrowerId;
      HTTP_API.post('/borrower/borrowerlist/',paramSet)
      .then(response => {
        // console.log("borrower list")
        console.log(response)
        if (response.data != ""){
          vm.form.borrowerList = vm.borrowerListAll.concat(response.data)
        } else {
          vm.form.borrowerList = vm.borrowerListAll
        }
      })
      .catch(function (error) {
        console.log(error.response)
      });
    },
    onRefresh() {
      console.log('refreshed!');
      console.log(this.form);
      this.getTablesData()

			var startDateFull = dateUtil.getCurrentDateMinusDays(366)
			var startDate = dateUtil.toDateString(startDateFull)

			var endDateFull = dateUtil.getCurrentDateMinusDays(1)
			var endDate = dateUtil.toDateString(endDateFull)
			var startDateMillis = startDateFull.getTime()

			var effectiveDate = this.convertDateFormat(this.form.effectiveDate)

      var token = sessionStorage.getItem('web-token')
      if (token) {
			  this.getBorrowerTabCharts(this, this.lenderId, this.form.borrower, this.form.parentBorrower, this.currencyCode, startDate, endDate, effectiveDate)
      }else{
        cognosLaunch.logoffCognos();
        setTimeout(() => {
          window.location.href = "/CR/"
        }, 1000)
      }
    },
    getTablesData(){
      var vm = this;
      vm.loading=true;
      var inputArr = vm.form.effectiveDate.split("-");
      var paramSet = {}
      paramSet.lenderId = vm.lenderId;
      paramSet.currCode = vm.currencyCode;
      paramSet.parentBorrowerId = vm.form.parentBorrower;
      paramSet.effectiveDate = inputArr[1] + "/" + inputArr[2] + "/" + inputArr[0];
      paramSet.borrowerId = vm.form.borrower;
      // console.log(paramSet);

      HTTP_API.post('/borrower/borrowerdashboarddata/',paramSet)
      .then(response => {
        console.log("borrower table data")
        console.log(response)
        vm.csData = response.data.programSummaryData
        vm.recallsData = response.data.dailyRecalls
        vm.pcData = response.data.pConcentration
        for (var i = 0; i < vm.pcData.length; i++){
          vm.pcData[i].program_CONCENTRATION_percent = vm.pcData[i].program_CONCENTRATION + " %"
        }
        vm.loading=false;
        vm.formloading=false;
      })
      .catch(function (error) {
        console.log(error.response)
        vm.loading=false;
        vm.formloading=false;
      });
    },
    formDateChange(inputDateStr){
      console.log(inputDateStr)
      var vm = this
      var inputDate = null;
      if (inputDateStr != null){
        var inputArr = inputDateStr.split("-");
        inputDate = new Date(parseInt(inputArr[0], 10) , parseInt(inputArr[1], 10) - 1, inputArr[2]);
      }
      if (inputDate < vm.form.earliestDate) {
        this.$message({
          duration: 0,
          showClose: true,
          message: 'Invalid date selected.  Historical data is limited to the prior 12 months.\nPlease select a date on or after '
           + vm.months[vm.form.earliestDate.getMonth()] + ' ' + vm.form.earliestDate.getDate() + ', ' + vm.form.earliestDate.getFullYear()
          + '.\nIf you require data beyond this historical period, please contact your eSecLending Relationship Manager.'
        });
        vm.form.effectiveDate = vm.form.defaultEffectiveDate;
      }
    },
    parentBorrowerChange(parentBorrowerId){
      console.log("parentBorrowerChange")
      console.log(parentBorrowerId)
      this.getBorrowerList(parentBorrowerId);
    },
    psHeaderStyle({row, column, rowIndex, columnIndex}) {
      return {  visibility: 'hidden'}
    },
    esHeaderStyle({row, column, rowIndex, columnIndex}) {
      return { color: '#44475C', backgroundColor: '#e6e6e6'}
    },
  },
  created() {
    this.getBorrowerData()
  },

}
</script>

<style scoped>

.main{
  white-space: nowrap;
}
.form {
  border-radius: 5px;
  padding: 5px 5px 5px 5px;
  background: #f2f2f2;
  opacity: 0.96;
  border: 2px solid #7cc1eb;
  width: 1150px;
}
.el-form-item {
  padding: 0;
  margin: 0;
}
.tableDescription{
  font-weight: bold;
  border-top: 1px solid #7D82A8;
  border-right: 1px solid #7D82A8;
  border-left: 1px solid #7D82A8;
  padding: 3px 3px 3px 6px;
  background-color: #cecece
}

.searchBar{
  /* border-top: 1px solid #7D82A8;
  border-right: 1px solid #7D82A8;
  border-left: 1px solid #7D82A8; */
}

.el-table {
  border: 1px solid #44475C;
  background-color: #FAFAFA;
}

.el-table >>> td {
  border-right: 1px solid #7D82A8;
  border-top: 1px solid #7D82A8;
  padding: 0 0 0 0;
}

.el-table >>> td:last-child {
  border-right: none;
}

.el-table >>> th {
  border-right: 1px solid #7D82A8;
  padding: 0 0 0 0;
}

.el-table >>> .el-table__empty-block{
  border-top: 1px solid #7D82A8;
}

.el-table >>> th:last-child {
  border-right: none;
}

.el-table >>> td .cell {
  word-break: normal;
  white-space: nowrap;
  font-size: 12px;
  padding-left: 0px
}

.el-table >>> th.el-table__cell .cell {
  word-break: normal;
  padding-left: 0;
  padding-right:0;
  font-size:12.5px;
}

.el-main >>> .row > * {
  padding: 0 0 0 0;
}

#borrower_frame2, #borrower_frame3{
  height: 350px
}

#borrower_frame1{
  max-height:350px
}
</style>